module.exports = __webpack_public_path__ + "fbf96044522e6e014357a4bdd8935f91.jpg";